import React from "react";
import styles from "./TestimonialCard.module.css";

interface TestimonialCardProp {
    rating: number;
    testimonial: string;
    name: string;
    title: string
    company: string
}

function TestimonialCard({rating, testimonial, name, title, company}: TestimonialCardProp) {
    return (
        <div className={styles.card}>

            {/* Stars */}
            <div className={styles.stars}>
                {Array.from({ length: 5 }, (_, i) => (
                    <span key={i} className={i < rating ? styles.starFilled : styles.starEmpty}>★</span>
                ))}
            </div>

            {/* Quote */}
            <p className={styles.testimonial}>"{testimonial}"</p>

            {/* Author */}
            <div className={styles.author}>
                <span className={styles.name}>{name}</span>
                <span className={styles.role}>{title}, {company}</span>
            </div>

        </div>
    );
}

export default TestimonialCard